<template>
    <div class="screen-out" v-if="$store.state.compare.compareShowMode==='screen'">
        <div class="screen-child" :class="{ active: item.isActive }"
                v-for="item in screenList" :key=item.title :id="'map'+item.title"
                @drop="drop($event, item.title)" @dragover.prevent
        >
            <div class="div-dashed" v-show="item.isLeafletOff"
                     @dragleave="screenList[item.title].isActive=false" @dragenter="screenList[item.title].isActive=true"
            >
                <div class="labelUp">请将图片拖至分屏</div>
                <div class="labelBottom">仅支持卫星图和专题图</div>
            </div>
            <div class="split-title" v-show="!item.isLeafletOff">{{item.curDataTitle}}</div>
        </div>
        <span class="sync-out" v-if="syncShow">
            <v-switch v-model="isSync" hide-details label="同步联动"></v-switch>
        </span>
        <div  v-on:click="quit">
            <img class="screen-quit" :src="'/dataLab/compareQuit.png'"/>
        </div>
        <div class="notSurpport" v-show="supportShow">不支持此类数据类型</div>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    
    export default {
        name: "SplitScreen",
        data() {
            return {
                screenList: [],
                roadButtonShow: false,
                supportShow: false,  // 暂无对这个操作
                syncShow: false,     // “同步联动”的按钮是否显示
                isSync: false,       // “同步联动”的switch值
                bottom: "37px",
            }
        },
        mounted() {
            this.screenList = this.$store.state.compare.screenList;
        },
        watch: {
            isSync(newVal){
                let maps = this.$store.state.compare.mapContent.maps;
                if (newVal) {
                    for (const key in maps) {
                        if (maps[key].hasOwnProperty("dragging")) {
                            // 找到有地图的数据进行事件注册
                            function maplink(e){
                                let _this = this;
                                for (const key in maps) {
                                    if (maps[key].hasOwnProperty("dragging")) {
                                        maps[key].setView(_this.getCenter(),_this.getZoom());
                                    }
                                }
                            }
                            maps[key].on({ "drag": maplink, "zoom": maplink });
                        }
                    }
                } else {
                    // 将下面代码由对array的，改成键值对的
                    for (const key in maps) {
                        if (maps[key].hasOwnProperty("dragging")) {
                            maps[key].off("drag")
                            maps[key].off("zoom")
                        }
                    }
                }
            },
            getCompareShowMode(newVal){
                if (newVal !== "screen"){
                    this.syncShow = false;
                    this.isSync = false;
                }
            }
        },
        computed: {
            ...mapGetters([ "getCompareShowMode" ]),
        },
        methods: {
            async drop (event, index) {
                let item = this.$store.state.compare.dropData;
                // 检验item是否有geojson和serviceUrl
                if ( !item.dataGeojson || !item.serviceUrl ) {
                    await this.getLayerData(item);
                }
                let geojson = item.dataGeojson;
                let serviceUrl = item.serviceUrl;
                let maps = this.$store.state.compare.mapContent.maps;
                let map = null;
                let curLayer;
                if(this.screenList[index].isLeafletOff){  // 没有切片的情况
                    map = this.utils.initMap('map'+index, geojson, this.$store.state);
                    curLayer = this.utils.addLayer(serviceUrl, geojson, this.$store.state);
                    // 根据index设置maps的key
                    let key = index==="0"? "topLeft": index==="1"? "topRight": index==="2"? "bottomLeft": "bottomRight";
                    maps[key] = map;
                    if(this.isSync){
                        // 地图联动实现  
                        function maplink(e){
                            let _this = this;
                            for (const key in maps) {
                                if (maps[key].hasOwnProperty("dragging")) {
                                    maps[key].setView(_this.getCenter(),_this.getZoom());
                                }
                            }
                        }
                        // 绑定
                        for (const key in maps) {
                            if (maps[key].hasOwnProperty("dragging")) {
                                // 找到有地图的数据进行事件注册
                                maps[key].on({ "drag": maplink, "zoom": maplink });
                            }
                        }
                    }
                } else {                                 // 已经有切片，再次拖拽覆盖
                    let key = index==="0"? "topLeft": index==="1"? "topRight": index==="2"? "bottomLeft": "bottomRight";
                    map = maps[key];
                    curLayer = this.screenList[index].curLayer;
                    this.$store.state.compare.mapContent.layerGroup.removeLayer(curLayer);
                    this.utils.calcCoordinates(map, geojson);
                    curLayer = this.utils.addLayer(serviceUrl, geojson, this.$store.state);
                }
                this.screenList[index].isLeafletOff = false;
                this.screenList[index].curDataTitle = item.name;
                this.screenList[index].curLayer = curLayer;
                this.screenList[index].isActive = false;
                // 统计当前有几个屏有地图
                let num = 0;
                for (const key in maps) {
                    if (maps[key].hasOwnProperty("dragging")) {
                        num += 1;
                    }
                }
                if (num >= 2) {
                    this.syncShow = true;
                    this.bottom = "40px";
                    this.isSync = true;
                }
            },
            getLayerData(item){
                return this.axios.get("/highmanage/seniorProductMgr/getProductServiceDetailById", {
                    params: {
                        productId: item.internalDemandId
                    }
                }).then(res => {
                    item.dataGeojson = JSON.parse(res.data.data.geo);
                    let symbol = res.data.data.serviceUrl.indexOf('?') === -1? "?": "&&";
                    item.serviceUrl = res.data.data.serviceUrl + symbol + "token=" + this.$store.state.user.token;
                })
            },
            quit(){
                this.syncShow = false;
                this.isSync = false;
                this.$store.state.myLabFucChecked = 0;
                this.eventVue.$emit("showDelivery");
                this.utils.quitCompare(this.$store.state.compare);
            }
        }
    }
</script>
<style scoped>
    .screen-out {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #000000B2;
        display: flex;
        flex-wrap: wrap;
    }
    .screen-child{
        width: 50%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
    }
    .div-dashed{
        border:1px dashed #C9C9C9;
        height: 96%;
        width: 96%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .labelUp{
        font-size: .24rem;
        color:rgba(234,234,234,1);
        margin: .1rem;
    }
    .labelBottom{
        font-size:.14rem;
        color:rgba(151,151,151,1);
        margin: .1rem;
    }
    .split-title{
        position: absolute;
        top: 0rem;
        padding: 0.3rem 1rem;
        background: rgba(36,51,56,0.77);
        font-size: 14px;
        box-shadow: 1px 1px 3px 0 rgba(0,0,0,0.5);
        border-radius: 6px;
        color: white;
        z-index: 1;
        text-align: center;
        overflow: hidden; /*内容超出宽度时隐藏超出部分的内容 */
        text-overflow: ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
        white-space: nowrap; /*不换行 */
    }
    .notSurpport{
        width:2.5rem;
        height:1rem;
        background:rgba(151,151,151,1);
        border-radius:6px;
        position: absolute;
        top:4.2rem;
        font-size: 16px;
        color:white;
        text-align:center;
        line-height: 1rem;
        z-index: 1;
    }
    .screen-quit{
        position: absolute;
        right: 0;
        top: 0;
        width: 2rem;
        height: 2rem;
        z-index: 1;
        cursor: pointer;
    }
    .sync-out{
        position: absolute;
        left: 40%;
        bottom: 37px;
        width: 150px;
        height: 60px;
        background: rgba(36,51,56,1);
        box-shadow: 2px 2px 4px 1px rgba(0,0,0,0.5);
        border-radius: .06rem;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
    }
</style>